<div class="flex flex-col"
     [ngClass]="{
      'items-start': alignment === 'left',
      'items-center': alignment === 'center',
      'items-end': alignment === 'right',
      'gap-1': size === 'small',
      'gap-6': size === 'large',
      'gap-2': size === 'normal'
     }">
  <h1 *ngIf="size === 'large'"  [class]="color">{{title}}</h1>
  <h2 *ngIf="size === 'normal'" [class]="color">{{title}}</h2>
  <h3 *ngIf="size === 'small'" [class]="color">{{ title }}</h3>
  <psc-line
    class="self-center"
    [color]="lineColor"
    [thickness]="lineThickness"
    [style.width.%]="lineWidthPercentage"></psc-line>
  <h5>{{subtitle}}</h5>
</div>
